import { Icon } from '../ui/Icon';

/** Search field above a task list (Tasks, My work). */
const TaskSearchBox = ({ value, onChange }: { value: string; onChange: (v: string) => void }) => (
  <div style={{ position: 'relative', flex: '1 1 240px', maxWidth: 360 }}>
    <span
      style={{
        position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
        color: 'var(--ink-4)', pointerEvents: 'none', display: 'flex',
      }}
    >
      <Icon name="search" size={14} />
    </span>
    <input
      className="input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => { if (e.key === 'Escape') onChange(''); }}
      placeholder="Search tasks, campaigns, people…"
      aria-label="Search tasks"
      style={{ paddingLeft: 32, paddingRight: value ? 30 : undefined }}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        title="Clear search"
        style={{
          position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)',
          border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--ink-4)', padding: 4, display: 'flex',
        }}
      >
        <Icon name="x" size={12} />
      </button>
    )}
  </div>
);

export default TaskSearchBox;
